var React = require('react');

function NM (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.48 59.6l-0.8-1.84h32.080l-0.16-52.4h-25.36l-25.52-0.96-2.72 59.68 7.36 0.32 0.32-4.8 15.44 0.56z"}));
}

NM.defaultProps = {"version":"1.1","width":"62","height":"80","viewBox":"0 0 62 80"};

module.exports = NM;

NM.default = NM;
